import SlideshowControls from './SlideshowControls'
export default SlideshowControls
